var classNames = {
  "stroke-accent-class": "stroke-accent",
  "accent-class": "with-accent"
};
var ACCENT_CLASS = classNames['accent-class'];
var STROKE_ACCENT_CLASS = classNames['stroke-accent-class'];
export { ACCENT_CLASS, STROKE_ACCENT_CLASS };